const TeaChannelDomainVRegionMap = {
  sg: "https://mcs-sg.tiktokv.com",
  va: "https://mcs-va.tiktokv.com",
  gcp: "https://mcs-ie.tiktokw.eu",
  "eu-ttp": "https://mcs-ie.tiktokw.eu",
  "eu-ttp2": "https://mcs-ie.tiktokw.eu",
  "us-ttp": "https://mcs.tiktokw.us",
  "us-ttp2": "https://mcs.tiktokw.us"
};
const TeaChannelDomainVGeoMap = {
  row: TeaChannelDomainVRegionMap.sg,
  eu: TeaChannelDomainVRegionMap["eu-ttp"],
  us: TeaChannelDomainVRegionMap["us-ttp"]
};
const TeaSdkUrlVRegionMap = {
  sg: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/log-sdk/collect/5.2/oversea/collect.js",
  va: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/log-sdk/collect/5.2/oversea/collect.js",
  gcp: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/log-sdk/collect/5.2/oversea/collect.js",
  "eu-ttp": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/log-sdk/collect/5.2/oversea/collect.js",
  "eu-ttp2": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/log-sdk/collect/5.2/oversea/collect.js",
  "us-ttp": "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/log-sdk/collect/5.2/collect.js",
  "us-ttp2": "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/log-sdk/collect/5.2/collect.js"
};
const TeaSdkUrlVGeoMap = {
  row: TeaSdkUrlVRegionMap.sg,
  eu: TeaSdkUrlVRegionMap["eu-ttp"],
  us: TeaSdkUrlVRegionMap["us-ttp"]
};
const TeaCspPreScriptUrlVRegionMap = {
  sg: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok-infra/csp/sdk-pre/tea.pre.js",
  va: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok-infra/csp/sdk-pre/tea.pre.js",
  gcp: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok-infra/csp/sdk-pre/tea.pre.js",
  "eu-ttp": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok-infra/csp/sdk-pre/tea.pre.js",
  "eu-ttp2": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok-infra/csp/sdk-pre/tea.pre.js",
  "us-ttp": "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/tiktok-infra/csp/sdk-pre/tea.pre.js",
  "us-ttp2": "https://lf16-cdn-tos.tiktokcdn-us.com/obj/static-tx/tiktok-infra/csp/sdk-pre/tea.pre.js"
};
const TeaCspPreScriptUrlVGeoMap = {
  row: TeaCspPreScriptUrlVRegionMap.sg,
  eu: TeaCspPreScriptUrlVRegionMap["eu-ttp"],
  us: TeaCspPreScriptUrlVRegionMap["us-ttp"]
};
const TeaGeckoSdkUrlVRegionMap = {
  sg: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/tea/collect.row.js",
  va: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/tea/collect.row.js",
  gcp: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/tea/collect.row.js",
  "eu-ttp": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/tea/collect.row.js",
  "eu-ttp2": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/tea/collect.row.js",
  "us-ttp": "https://lf16-tiktok-common.tiktokcdn-us.com/obj/tiktok-web-common-tx/tiktok/fe/common/gando_libs/tea/collect.ttp.js",
  "us-ttp2": "https://lf16-tiktok-common.tiktokcdn-us.com/obj/tiktok-web-common-tx/tiktok/fe/common/gando_libs/tea/collect.ttp.js"
};
const TeaGeckoSdkUrlVGeoMap = {
  row: TeaGeckoSdkUrlVRegionMap.sg,
  eu: TeaGeckoSdkUrlVRegionMap["eu-ttp"],
  us: TeaGeckoSdkUrlVRegionMap["us-ttp"]
};
const TeaGeckoCspPreScriptUrlVRegionMap = {
  sg: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/tea/collect.pre.row.js",
  va: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/tea/collect.pre.row.js",
  gcp: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/tea/collect.pre.row.js",
  "eu-ttp": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/tea/collect.pre.row.js",
  "eu-ttp2": "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/fe/common/gando_libs/tea/collect.pre.row.js",
  "us-ttp": "https://lf16-tiktok-common.tiktokcdn-us.com/obj/tiktok-web-common-tx/tiktok/fe/common/gando_libs/tea/collect.pre.ttp.js",
  "us-ttp2": "https://lf16-tiktok-common.tiktokcdn-us.com/obj/tiktok-web-common-tx/tiktok/fe/common/gando_libs/tea/collect.pre.ttp.js"
};
const TeaGeckoCspPreScriptUrlVGeoMap = {
  row: TeaGeckoCspPreScriptUrlVRegionMap.sg,
  eu: TeaGeckoCspPreScriptUrlVRegionMap["eu-ttp"],
  us: TeaGeckoCspPreScriptUrlVRegionMap["us-ttp"]
};
const TeaResources = {
  channelDomainVRegionMap: TeaChannelDomainVRegionMap,
  channelDomainVGeoMap: TeaChannelDomainVGeoMap,
  sdkUrlVRegionMap: TeaSdkUrlVRegionMap,
  sdkUrlVGeoMap: TeaSdkUrlVGeoMap,
  cspPreScriptUrlVRegionMap: TeaCspPreScriptUrlVRegionMap,
  cspPreScriptUrlVGeoMap: TeaCspPreScriptUrlVGeoMap,
  geckoSdkUrlVRegionMap: TeaGeckoSdkUrlVRegionMap,
  geckoSdkUrlVGeoMap: TeaGeckoSdkUrlVGeoMap,
  geckoCspPreScriptUrlVRegionMap: TeaGeckoCspPreScriptUrlVRegionMap,
  geckoCspPreScriptUrlVGeoMap: TeaGeckoCspPreScriptUrlVGeoMap
};
export {
  TeaChannelDomainVGeoMap,
  TeaChannelDomainVRegionMap,
  TeaCspPreScriptUrlVGeoMap,
  TeaCspPreScriptUrlVRegionMap,
  TeaGeckoCspPreScriptUrlVGeoMap,
  TeaGeckoCspPreScriptUrlVRegionMap,
  TeaGeckoSdkUrlVGeoMap,
  TeaGeckoSdkUrlVRegionMap,
  TeaResources,
  TeaSdkUrlVGeoMap,
  TeaSdkUrlVRegionMap
};

//# sourceMappingURL=tea.js.map